import React, { useEffect, useState } from 'react';
import { useLive } from '../../live.jsx';
import { Link, useSearchParams } from 'react-router-dom';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import PageHero from '../../components/PageHero.jsx';
import { pickLang } from '../../content.jsx';
import { fetchPosts, postDate } from '../../news.js';

export function PostCard({ post }) {
  const { t, lang } = useI18n();
  return (
    <Link to={`/news/${post.slug}`} className="news-card">
      <div className="news-card-img">{post.cover ? <img src={post.cover} alt="" loading="lazy" decoding="async" /> : <span aria-hidden="true">📰</span>}</div>
      <div className="news-card-body">
        <p className="news-meta"><span className="news-cat">{t(`news.categories.${post.category || 'news'}`)}</span> · {postDate(post.publishedAt, lang)}</p>
        <h3>{pickLang(post.title, lang)}</h3>
        {pickLang(post.excerpt, lang) && <p className="muted">{pickLang(post.excerpt, lang)}</p>}
        <span className="news-more">{t('news.readMore')} →</span>
      </div>
    </Link>
  );
}

// /news — published posts, newest first, 12 per page.
export default function News() {
  const { t } = useI18n();
  usePageTitle('news.title');
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get('page')) || 1);
  const [data, setData] = useState(null);
  const [tick, setTick] = useState(0);
  useLive(['news'], () => setTick((x) => x + 1)); // a post published / changed: read again, silently
  useEffect(() => {
    let alive = true;
    if (!tick) setData(null);
    fetchPosts(12, page).then((d) => alive && setData(d)).catch(() => alive && setData({ items: [], total: 0, pageSize: 12 }));
    return () => { alive = false; };
  }, [page, tick]); // eslint-disable-line react-hooks/exhaustive-deps
  const pages = data ? Math.ceil(data.total / data.pageSize) : 1;
  return (
    <>
      <PageHero title={t('news.title')} lead={t('news.lead')} />
      <section className="section section-tight">
        <div className="container">
          {!data && <p className="muted">{t('common.loading')}</p>}
          {data && !data.items.length && <div className="empty-state"><p className="muted">{t('news.empty')}</p></div>}
          {data && data.items.length > 0 && <div className="news-grid">{data.items.map((p) => <PostCard key={p.id} post={p} />)}</div>}
          {pages > 1 && (
            <nav className="pager" aria-label={t('news.pages')}>
              <button type="button" className="btn btn-ghost btn-sm" disabled={page <= 1} onClick={() => setParams({ page: String(page - 1) })}>← {t('news.newer')}</button>
              <span className="muted small">{page} / {pages}</span>
              <button type="button" className="btn btn-ghost btn-sm" disabled={page >= pages} onClick={() => setParams({ page: String(page + 1) })}>{t('news.older')} →</button>
            </nav>
          )}
        </div>
      </section>
    </>
  );
}
